// Refresh vs resume, the same on phones and desktops. A refresh (or the browser reloading the
// page) must not ask for a new photo; coming back after leaving the test, from another device or
// after signing out must. sessionStorage (per tab) worked on desktops but not on phones, where
// tabs are discarded and restored and links open in in-app browsers. Instead, the test page
// stamps "last active" in localStorage while it is open; a resume within ACTIVE_WINDOW_MS of that
// stamp, in the same browser, is a refresh. Signout clears the stamps.
const PREFIX = "proctoringActive:";
export const ACTIVE_STAMP_MS = 15 * 1000;
const ACTIVE_WINDOW_MS = 2 * 60 * 1000;

export const markTestActive = (examId) => {
  try {
    if (examId) window.localStorage.setItem(PREFIX + examId, String(Date.now()));
  } catch (e) {
    // Storage unavailable: the next resume asks for a photo.
  }
};

export const wasTestActiveRecently = (examId) => {
  try {
    const at = Number(window.localStorage.getItem(PREFIX + examId));
    return Number.isFinite(at) && at > 0 && Date.now() - at < ACTIVE_WINDOW_MS;
  } catch (e) {
    return false;
  }
};

export const clearTestActivity = () => {
  try {
    Object.keys(window.localStorage)
      .filter((key) => key.startsWith(PREFIX))
      .forEach((key) => window.localStorage.removeItem(key));
  } catch (e) {
    // nothing to clear
  }
};
